interface TelegramBackButton {
  show(): void;
  hide(): void;
  onClick(callback: () => void): void;
  offClick(callback: () => void): void;
}

interface TelegramWebApp {
  initData: string;
  colorScheme?: 'light' | 'dark';
  ready(): void;
  expand(): void;
  openLink(url: string): void;
  BackButton?: TelegramBackButton;
}

declare global {
  interface Window {
    Telegram?: { WebApp?: TelegramWebApp };
  }
}

function webApp(): TelegramWebApp | undefined {
  return window.Telegram?.WebApp;
}

export function initData(): string {
  return webApp()?.initData || process.env.REACT_APP_DEV_INIT_DATA || '';
}

export function startTelegramApp(): void {
  const app = webApp();
  app?.ready();
  app?.expand();
}

export function openLink(url: string): void {
  const app = webApp();
  if (app?.initData) {
    app.openLink(url);
  } else {
    window.open(url, '_blank', 'noopener');
  }
}

export function showBackButton(onClick: () => void): () => void {
  const button = webApp()?.initData ? webApp()?.BackButton : undefined;
  if (!button) return () => {};

  button.onClick(onClick);
  button.show();
  return () => {
    button.offClick(onClick);
    button.hide();
  };
}

export function isInsideTelegram(): boolean {
  return !!webApp()?.initData;
}
